module.exports = __webpack_public_path__ + "img/img55.9f2c13bd.png";